import axios from 'axios';
import { getAuth } from 'firebase/auth';

const API_BASE_URL = '/.netlify/functions';

async function getIdToken() {
  const auth = getAuth();
  const user = auth.currentUser;
  if (!user) throw new Error('Użytkownik nie jest zalogowany');
  return user.getIdToken(/* forceRefresh= */ true);
}

export const fetchLegalAdvice = async (query, chatHistory = [], isContinuation = false) => {
  const idToken = await getIdToken();
  try {
    const response = await axios.post(
      `${API_BASE_URL}/fetch-legal-advice`,
      { query, chatHistory, isContinuation },
      { headers: { Authorization: `Bearer ${idToken}` } }
    );
    return response.data; // Zwracamy cały obiekt data
  } catch (error) {
    console.error('Error fetching legal advice:', error.message);
    const errorMessage = error.response?.data?.error || 'Wystąpił błąd podczas generowania porady prawnej. Spróbuj ponownie później.';
    throw new Error(errorMessage);
  }
};

export const generateLegalDocument = async (documentType, details) => {
  const idToken = await getIdToken();
  try {
    const response = await axios.post(
      `${API_BASE_URL}/generate-legal-document`,
      { documentType, details },
      { headers: { Authorization: `Bearer ${idToken}` } }
    );
    // ZMIANA: Zwracamy cały obiekt danych, a nie tylko .content
    return response.data; 
  } catch (error) {
    console.error('Error generating legal document:', error.message);
    // Dodano obsługę błędu z odpowiedzi serwera, analogicznie do fetchLegalAdvice
    const errorMessage = error.response?.data?.error || 'Wystąpił błąd podczas generowania dokumentu. Spróbuj ponownie później.';
    throw new Error(errorMessage);
  }
};